// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { PlayerGameStatus } from '../tbs/player-game-status.js';
import { PlayerKind } from '../tbs/player-kind.js';
import { PlayerTurnStatus } from '../tbs/player-turn-status.js';


export class Player implements flatbuffers.IUnpackableObject<PlayerT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):Player {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPlayer(bb:flatbuffers.ByteBuffer, obj?:Player):Player {
  return (obj || new Player()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPlayer(bb:flatbuffers.ByteBuffer, obj?:Player):Player {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Player()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

id():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

profileId():bigint {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : BigInt('-1');
}

inviteId():string|null
inviteId(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
inviteId(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

botId():string|null
botId(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
botId(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

isLocal():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

kind():PlayerKind {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : PlayerKind.OpenSlot;
}

dname():string|null
dname(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
dname(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

dnamePlaceholder():string|null
dnamePlaceholder(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
dnamePlaceholder(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

color1():number {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

color2():number {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

money():number {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

turnStatus():PlayerTurnStatus {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : PlayerTurnStatus.Waiting;
}

gameStatus():PlayerGameStatus {
  const offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : PlayerGameStatus.Active;
}

static startPlayer(builder:flatbuffers.Builder) {
  builder.startObject(13);
}

static addId(builder:flatbuffers.Builder, id:number) {
  builder.addFieldInt16(0, id, 0);
}

static addProfileId(builder:flatbuffers.Builder, profileId:bigint) {
  builder.addFieldInt64(1, profileId, BigInt('-1'));
}

static addInviteId(builder:flatbuffers.Builder, inviteIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, inviteIdOffset, 0);
}

static addBotId(builder:flatbuffers.Builder, botIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, botIdOffset, 0);
}

static addIsLocal(builder:flatbuffers.Builder, isLocal:boolean) {
  builder.addFieldInt8(4, +isLocal, +false);
}

static addKind(builder:flatbuffers.Builder, kind:PlayerKind) {
  builder.addFieldInt8(5, kind, PlayerKind.OpenSlot);
}

static addDname(builder:flatbuffers.Builder, dnameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, dnameOffset, 0);
}

static addDnamePlaceholder(builder:flatbuffers.Builder, dnamePlaceholderOffset:flatbuffers.Offset) {
  builder.addFieldOffset(7, dnamePlaceholderOffset, 0);
}

static addColor1(builder:flatbuffers.Builder, color1:number) {
  builder.addFieldInt32(8, color1, 0);
}

static addColor2(builder:flatbuffers.Builder, color2:number) {
  builder.addFieldInt32(9, color2, 0);
}

static addMoney(builder:flatbuffers.Builder, money:number) {
  builder.addFieldInt32(10, money, 0);
}

static addTurnStatus(builder:flatbuffers.Builder, turnStatus:PlayerTurnStatus) {
  builder.addFieldInt8(11, turnStatus, PlayerTurnStatus.Waiting);
}

static addGameStatus(builder:flatbuffers.Builder, gameStatus:PlayerGameStatus) {
  builder.addFieldInt8(12, gameStatus, PlayerGameStatus.Active);
}

static endPlayer(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createPlayer(builder:flatbuffers.Builder, id:number, profileId:bigint, inviteIdOffset:flatbuffers.Offset, botIdOffset:flatbuffers.Offset, isLocal:boolean, kind:PlayerKind, dnameOffset:flatbuffers.Offset, dnamePlaceholderOffset:flatbuffers.Offset, color1:number, color2:number, money:number, turnStatus:PlayerTurnStatus, gameStatus:PlayerGameStatus):flatbuffers.Offset {
  Player.startPlayer(builder);
  Player.addId(builder, id);
  Player.addProfileId(builder, profileId);
  Player.addInviteId(builder, inviteIdOffset);
  Player.addBotId(builder, botIdOffset);
  Player.addIsLocal(builder, isLocal);
  Player.addKind(builder, kind);
  Player.addDname(builder, dnameOffset);
  Player.addDnamePlaceholder(builder, dnamePlaceholderOffset);
  Player.addColor1(builder, color1);
  Player.addColor2(builder, color2);
  Player.addMoney(builder, money);
  Player.addTurnStatus(builder, turnStatus);
  Player.addGameStatus(builder, gameStatus);
  return Player.endPlayer(builder);
}

unpack(): PlayerT {
  return new PlayerT(
    this.id(),
    this.profileId(),
    this.inviteId(),
    this.botId(),
    this.isLocal(),
    this.kind(),
    this.dname(),
    this.dnamePlaceholder(),
    this.color1(),
    this.color2(),
    this.money(),
    this.turnStatus(),
    this.gameStatus()
  );
}


unpackTo(_o: PlayerT): void {
  _o.id = this.id();
  _o.profileId = this.profileId();
  _o.inviteId = this.inviteId();
  _o.botId = this.botId();
  _o.isLocal = this.isLocal();
  _o.kind = this.kind();
  _o.dname = this.dname();
  _o.dnamePlaceholder = this.dnamePlaceholder();
  _o.color1 = this.color1();
  _o.color2 = this.color2();
  _o.money = this.money();
  _o.turnStatus = this.turnStatus();
  _o.gameStatus = this.gameStatus();
}
}

export class PlayerT implements flatbuffers.IGeneratedObject {
constructor(
  public id: number = 0,
  public profileId: bigint = BigInt('-1'),
  public inviteId: string|Uint8Array|null = null,
  public botId: string|Uint8Array|null = null,
  public isLocal: boolean = false,
  public kind: PlayerKind = PlayerKind.OpenSlot,
  public dname: string|Uint8Array|null = null,
  public dnamePlaceholder: string|Uint8Array|null = null,
  public color1: number = 0,
  public color2: number = 0,
  public money: number = 0,
  public turnStatus: PlayerTurnStatus = PlayerTurnStatus.Waiting,
  public gameStatus: PlayerGameStatus = PlayerGameStatus.Active
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const inviteId = (this.inviteId !== null ? builder.createString(this.inviteId!) : 0);
  const botId = (this.botId !== null ? builder.createString(this.botId!) : 0);
  const dname = (this.dname !== null ? builder.createString(this.dname!) : 0);
  const dnamePlaceholder = (this.dnamePlaceholder !== null ? builder.createString(this.dnamePlaceholder!) : 0);

  return Player.createPlayer(builder,
    this.id,
    this.profileId,
    inviteId,
    botId,
    this.isLocal,
    this.kind,
    dname,
    dnamePlaceholder,
    this.color1,
    this.color2,
    this.money,
    this.turnStatus,
    this.gameStatus
  );
}
}
